import { RemoveClusteringContext } from '@/context/Context';
import { useContext } from 'react';
import CancelModal from '@/app/common/components/CancelModal';
import { errorMessage, successMessage, warningMessage } from '@/utils/toast';
import { useDeleteClusteringHistoryMutation } from '../api/clusteringApi';

const ClusteringProviders = ({ children }) => {
  const { keyword, setShow, show, task_id } = useContext(
    RemoveClusteringContext
  );
  const [deleteClusteringHistory] = useDeleteClusteringHistoryMutation();

  return (
    <>
      <CancelModal
        desc={`آیا مطئنید میخواهید تاریخچه خوشه بندی ${keyword} را حذف کنید؟`}
        setShow={setShow}
        show={show}
        submitFunc={() => {
          deleteClusteringHistory(task_id)
            .unwrap()
            .then(({ code }) => {
              if (code) {
                if (code == '200')
                  successMessage('حذف خوشه بندی با موفقیت انجام شد.');
                else if (code == '403')
                  warningMessage(
                    'در حال جستجو هستی. لطفا صبر کن تا جستجو تمام بشه یا ابتدا جستجو رو متوقف کن'
                  );
                else errorMessage('خطای ناشناخته در حذف خوشه بندی');
              }
            })
            .catch(err => {
              console.error('Error fetching data:', err);
              errorMessage('در انجام عملیات خطایی رخ داد.');
            });
        }}
        submitTitle="آره، حذف بشه"
        title={'حذف خوشه بندی '}
      />
      {children}
    </>
  );
};

export default ClusteringProviders;
